import validator from './validator.reducer';

export default validator;


// WEBPACK FOOTER //
// src/main/components/validator/store/reducers/index.js